import { useMemoDispose } from "./hook";

export function useObjectUrl(blob: Blob | undefined) {
  return useMemoDispose(
    () => blob && URL.createObjectURL(blob),
    (url) => url && URL.revokeObjectURL(url),
    [blob],
  );
}
